import { render, staticRenderFns } from "./SpModalFormTransfer.vue?vue&type=template&id=39fd08c7&"
import script from "./SpModalFormTransfer.vue?vue&type=script&lang=js&"
export * from "./SpModalFormTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports